'use client';

import TravelCostCalculator from '@/components/girl/travel-cost-calculator';
import { moneyFormatter } from '@/components/girl/utils';
import {
  attendantFeeHourPrice,
  attendantFeeHours,
  attendantFeeNotice,
  attendantFeePrice,
  attendantFeeTitle,
  attendantFeeTravelDistance,
  attendantTravelCostsCosts,
  attendantTravelCostsDistance,
  attendantTravelCostsNotice,
  attendantTravelCostsTravelFeeTitle,
  priceTemplatePricePerDay,
  priceTemplateSurchargeFFM,
  priceTemplateSurchargeMMF,
  priceTemplateSurchargeSwinger,
} from '@bells/i18n';
import {
  AttendantSearchSingleResponse,
  ThreesomeStatus,
} from '@bells/schema/models/attendant';
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from '@bells/ui/components/alert';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@bells/ui/components/card';

import { Info } from 'lucide-react';
import React, { useMemo } from 'react';

export const GirlPrices = ({
  data,
}: {
  data?: AttendantSearchSingleResponse;
}) => {
  return (
    <Card className='m-0 w-full border-0 bg-transparent p-0 shadow-none'>
      <CardContent className='flex w-full flex-col space-y-4 px-0'>
        <Alert variant={'info'}>
          <Info className='h-4 w-4' />
          <AlertTitle>Hinweis</AlertTitle>
          <AlertDescription>{attendantFeeNotice()} </AlertDescription>
        </Alert>

        <div className='grid grid-cols-3 rounded-xl [&>*:nth-child(3n)]:mr-8 [&>*]:p-1.5'>
          <div className='hidden break-all border-b text-sm uppercase text-muted-foreground lg:block'>
            {attendantFeeHours()}
          </div>
          <div className='hidden break-all border-b text-sm uppercase text-muted-foreground lg:block'>
            {attendantFeePrice()}
          </div>

          <div className='hidden break-all border-b text-sm uppercase text-muted-foreground lg:block'></div>
          {(data?.prices ?? [])
            .filter((df) => df.price !== null)
            .sort((a, b) => a.hours - b.hours)
            .map((df) => {
              return (
                <React.Fragment key={df.hours}>
                  <div className='border-b text-[14px]'>
                    {attendantFeeHourPrice({ hours: df.hours })}
                  </div>
                  <div className='border-b text-[14px] font-medium'>
                    {moneyFormatter.format(df.price ?? 0)}
                  </div>
                  <div className='border-b text-[14px] text-muted-foreground'>
                    {df.maxDistance
                      ? attendantFeeTravelDistance({ km: df.maxDistance })
                      : '-'}
                  </div>
                </React.Fragment>
              );
            })}

          {data && data.perExtraDay && (
            <>
              <div className='border-b text-[14px]'>
                {priceTemplatePricePerDay()}
              </div>
              <div className='col-span-2 border-b text-[14px] font-medium'>
                {moneyFormatter.format(data.perExtraDay)}
              </div>
            </>
          )}

          {data &&
            data.ffmPrice &&
            (data.threesome ?? []).includes(ThreesomeStatus.FFM) && (
              <>
                <div className='w-full border-b text-[14px]'>
                  {priceTemplateSurchargeFFM()}
                </div>
                <div className='col-span-2 w-full border-b text-[14px] font-medium'>
                  {data.ffmPrice}%
                </div>
              </>
            )}
          {data &&
            data.mmfPrice &&
            (data.threesome ?? []).includes(ThreesomeStatus.MMF) && (
              <>
                <div className='w-full border-b text-[14px]'>
                  {priceTemplateSurchargeMMF()}
                </div>
                <div className='col-span-2 w-full border-b text-[14px] font-medium'>
                  {data.mmfPrice}%
                </div>
              </>
            )}
          {data &&
            data.swingerPrice &&
            (data.threesome ?? []).includes(ThreesomeStatus.SWINGER) && (
              <>
                <div className='w-full text-[14px]'>
                  {priceTemplateSurchargeSwinger()}
                </div>
                <div className='col-span-2 w-full text-[14px] font-medium'>
                  {data.swingerPrice}%
                </div>
              </>
            )}
        </div>
      </CardContent>
    </Card>
  );
};
